var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swap-button",on:{"click":_vm.goSwap}},[_c('span',[_vm._v(_vm._s(_vm.$t('trading_info.text_6')))]),_c('img',{attrs:{"src":require("../assets/arrow.png"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }